<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{label}}</v-card-title>

        <v-card-text>
            <v-text-field
                autocomplete="off"
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
            >
                <!--<v-menu
                    bottom
                    offset-y
                    slot="append-outer"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>
            
                    <v-list>
                        <v-list-item
                            v-on:click="onClickDoSomething()"
                        >
                            <v-list-item-title>Do Something...</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> -->
            </v-text-field>

            <v-card
                elevation="3"
                class="mx-auto"
                height="300"
                style="overflow-y: scroll"
            >
                <v-list-item 
                    v-for="(item, index) in available_items"
                    :key="index"
                    v-on:click="onClickItem(item)"
                    height="25"
                >
                    <v-avatar>
                        <v-icon
                            v-if="!value.includes(item.value)"
                        >
                            mdi-checkbox-blank-outline
                        </v-icon>
                        <v-icon
                            v-else
                            color="primary"
                        >
                            mdi-checkbox-marked
                        </v-icon>
                    </v-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{item.text}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>


                <!--<v-virtual-scroll
                    :items="available_items"
                    itemHeight="50"
                    :bench="0"
                    height="300"
                >   
                    <template v-slot:default="{ item }">
                        
                    </template>
                    </v-virtual-scroll>-->
            </v-card>

            <div 
                class="chip_row"
                style="min-height: 50px; margin-top: 15px;"
            >

                <div class="chip_container">
                    <v-chip
                        v-for="(item, index) in selected_items"
                        style="margin-right: 5px; margin-bottom: 5px;"
                        :key="index"
                        close
                        v-on:click:close="onClickClose(item)"
                    >
                        {{item.text}}
                    </v-chip>

                    <v-chip
                        v-if="value.length == 0"
                        style="margin-right: 5px; margin-bottom: 5px; color: rgba(0,0,0,0.25)"
                    >
                        {{no_item_text}}
                    </v-chip>
                </div>
            </div>
            
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            items: [],
            value: [],
            label: 'Select Items',
            no_item_text: 'None Selected',
            full_text: null,
        }
    },

    methods: {

        showDialog(props)
        {
            this.items = _.cloneDeep(props.items);
            this.value = _.cloneDeep(props.value);
            this.label = _.cloneDeep(props.label);
            this.no_item_text = _.cloneDeep(props.no_item_text);
            this.full_text = null;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false; 
            this.$emit('ok', _.cloneDeep(this.value));
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickItem(item) 
        {
            var included = this.value.includes(item.value);
            
            if ( included )
            {
                this.value = this.value.filter(value => value != item.value);
            }
            else
            {
                if ( item.value == 'any_enum_value' )
                {
                    this.value = ['any_enum_value'];
                }
                else
                {
                    this.value = this.value.filter(value => value != 'any_enum_value');
                    this.value.push(item.value);
                }
            }
        },

        onClickClose(remove_item) {
            let new_value = _.cloneDeep(this.value);
            new_value = new_value.filter(value => value != remove_item.value);
            this.value = new_value;
        },

    },

    computed: {
        available_items() {
            let full_text = this.full_text;
            if ( full_text == null ) full_text = "";
            full_text = full_text.trim();

            if ( full_text.length == 0 )
                return this.items;

            return this.items.filter(item => item.text.toLowerCase().includes(full_text));
        },

        selected_items() {
            return this.items.filter(item => this.value.includes(item.value));
        }
    },
}
</script>

<style lang="scss" scoped>
.label
{
    color: rgba(0,0,0,0.38);
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 400;
}

.chip_row
{
    display: flex;
}

.chip_container
{
    flex-grow: 1;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding-bottom: 5px;
    padding-top: 5px;
}

.edit_container
{
    flex-grow: 0;
}
</style>